// extracted by mini-css-extract-plugin
export var iconContainer = "_bh-0";
export var metricCardsContainer = "_bh-1";